import * as z from "zod";

import { partnerSummarySchema } from "./shared";

/** Every partner, newest first. There are few enough not to page. */
export const listPartners = {
  name: "listPartners" as const,
  input: z.object({ searchQuery: z.string().max(200).optional() }),
  output: z.object({ partners: z.array(partnerSummarySchema) }),
};
